<template>
  <div>
    <div v-if="!loading">
      <div v-if="quotes.length > 0">
        <v-card :id="`quotes-${i}`" v-for="(quote, i) in quotes" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4">
          <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
            <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
              <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                <img src="/images/icons/car-g.png" class="tw-h-16 lg:tw-h-auto tw-mr-2 lg:tw-mr-4" alt="car icon">
                <div class="tw-px-2 md:tw-px-3">
                  <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">Motor Insurance</h3>
                  <p class="c-blue-text tw-text-sm tw-mt-2 md:tw-mt-4">Request For Quotation</p>
                </div>
              </div>
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-6 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400 tw-mt-5 md:tw-mt-0">
                <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">{{ quote.contact ? quote.contact.firstName + ' ' + quote.contact.lastName : authenticatedUser.name }}</h3>
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ quote.vehicle.make + ' ' + quote.vehicle.model + ', ' + quote.vehicle.yearOfManufacture }}</h3>
              </div>
              <div class="tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                <h4 class="c-blue-text tw-text-sm tw-w-full"> <strong>Phone:</strong> {{ authenticatedUser.phone_number }}</h4>
              </div>
            </div>
          </div>
          <div class="tw-w-full tw-px-0 md:tw-px-8">
            <v-stepper alt-labels>
              <v-stepper-header>
                <v-stepper-step
                    step="1"
                    :complete="progress(quote) > 0"
                >
                  Personal Details
                </v-stepper-step>

                <v-divider :color="progress(quote) > 0 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="2"
                    :complete="progress(quote) > 35"
                >
                  Vehicle Details
                </v-stepper-step>

                <v-divider :color="progress(quote) > 35 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="3"
                    :complete="progress(quote) > 67"
                >
                  Cover Summary
                </v-stepper-step>

                <v-divider :color="progress(quote) > 67 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    :complete="progress(quote) === 100"
                    step="4">
                  Make Payment
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </div>
          <div class="tw-w-full tw-flex tw-justify-end tw-mt-3 md:tw-mt-6">
            <button disabled @click="resumeQuote(quote)" :id="`resume-quotes-${i}`"><span class="c-yellow-text">Resume Quote</span><v-icon color="secondary">mdi-chevron-right</v-icon></button>
          </div>
        </v-card>
      </div>
      <div v-else class="tw-w-full tw-mt-5 md:tw-mt-10">
        <v-card class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center tw-py-24">
          <div class="tw-w-full tw-flex tw-justify-center">
            <v-icon size="70" color="gray">mdi-file</v-icon>
          </div>
          <p class="tw-text-2xl tw-mt-6 c-gray-text">No recent quotes available</p>
        </v-card>
      </div>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'Quotes',
  data() {
    return {
      quotes: [],
      loading: true,
      page: 0,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  mounted() {
    const cachedInfo = localStorage.getItem('formPayload');
    if (cachedInfo) {
      const customerId = JSON.parse(cachedInfo)?.customerId;
      this.getQuotes(customerId);
    }
  },
  methods: {
    async getQuotes(customerId) {
      const res = await axios.post('/motor/api/quote/list', { customerId });
      if (res?.data?.message === 'OK') {
        this.quotes = res?.data?.data;
        this.page += 1;
      }
      this.loading = false;
      this.$emit('saved-quotes-loaded', this.quotes);
    },
    resumeQuote(quote) {
      localStorage.setItem('resummingQote', JSON.stringify({ quote, time: Date.now() }));
    },
    filterCar(quote) {
      return quote;
    },
    progress(quote) {
      let step = 0;
      if (quote.status === 'Policy' || quote.policyNumber) {
        step = 100;
      } else if ('mainBranchCode' in quote && quote.mainBranchCode !== '') {
        step = 80;
      } else if (quote.vehicle && 'engineNo' in quote.vehicle && quote.vehicle.engineNo !== '') {
        step = 66.66;
      } else if ('startDate' in quote && quote.startDate !== '') {
        step = 33.33;
      }
      return step;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-stepper {
  box-shadow: none!important;
}
</style>
